export default __webpack_public_path__ + "static/AntiqueOliveStd-Nord-4f146340eb42c5056442d4de3e5d8546.woff";